// extracted by mini-css-extract-plugin
export var label = "ifJBWKs_aG38ZY3boYpa";
export var labelHidden = "vxYDwCM_LEYQ2FuDaJAk";